import React from 'react'
import {ListChildComponentProps} from 'react-window'
import {KTIcon} from '../../../_metronic/helpers'
import {ISenderId} from '../SMSBroadCast/core/_model'

interface RowData {
  items: ISenderId[]
}

export const SenderRow = React.memo(({index, style, data}: ListChildComponentProps<RowData>) => {
  const sender = data.items[index]

  return (
    <div style={style}>
      <div className='fw-bold text-gray-800 fs-6 d-flex align-items-center gap-2 px-3'>
        <KTIcon iconName='triangle' className='fs-2' />
        {sender.sender}
      </div>
    </div>
  )
})

SenderRow.displayName = 'SenderRow'
